function BackArrowIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='16px'
      height='14px'
      viewBox='0 0 16 14'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}>
      <defs>
        <polygon
          id='back-arrow-1'
          points='6.7 13.7000002 8.1 12.3000002 3.8 8.00000019 16 8.00000019 16 6.00000019 3.8 6.00000019 8.1 1.70000019 6.7 0.300000191 0 7.00000019'
        />
      </defs>
      <g id='Metric-Component-Spec' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='Metric-Component-with-Back-Arrow' transform='translate(-53.000000, -49.000000)'>
          <g id='Back-Arrow' transform='translate(53.000000, 49.000000)'>
            <mask id='back-arrow-mask-2' fill='white'>
              <use xlinkHref='#back-arrow-1' />
            </mask>
            <use id='Mask' fill='#0F1226' fillRule='nonzero' xlinkHref='#back-arrow-1' />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BackArrowIcon;
